import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Grocries from "../Allcomponent/grocries"
function Grocoriess(){
    return(
        <>
        <Banner/>
        <Cards/>
        <Grocries/>
        </>
    )
}
export default Grocoriess